export type AuditTone = 'success' | 'info' | 'danger' | 'neutral';

export function actionToTone(action: string): AuditTone {
  const suffix = action.split('.')[1] ?? '';
  if (['create', 'import', 'activate', 'add', 'enable', 'reactivate', 'start'].includes(suffix)) return 'success';
  if (['update', 'assign', 'reopen', 'confirm', 'reassign'].includes(suffix)) return 'info';
  if (['cancel', 'delete', 'disable', 'suspend', 'remove', 'skip', 'end'].includes(suffix)) return 'danger';
  return 'neutral';
}
